import { motion } from "framer-motion";
import { fadeUp, staggerChild, staggerContainer } from "../lib/motion";

const offerings = [
  "Offer refinement and packaging",
  "Backend monetization design",
  "Funnel and conversion strategy",
  "Lead capture and nurture systems",
  "Sales flow architecture",
  "Customer journey cleanup",
  "Smoother delivery and stronger retention",
  "Infrastructure that adds real leverage",
];

export const Solution = () => {
  return (
    <section
      data-testid="solution-section"
      className="relative py-24 md:py-32 lg:py-44 px-6 md:px-12 lg:px-20 max-w-[1500px] mx-auto"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <motion.div {...fadeUp} className="flex items-center gap-3 mb-6">
            <span className="eyebrow">03 — Solution</span>
            <span className="block w-8 h-px bg-[#282930]" />
          </motion.div>
          <motion.h2
            {...fadeUp}
            className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight"
          >
            We build the infrastructure{" "}
            <span className="italic text-[#C9A26B]">behind the brand.</span>
          </motion.h2>

          <motion.p
            {...fadeUp}
            className="mt-8 text-[#A8A39D] leading-relaxed max-w-[44ch]"
          >
            Chadow Marketing is for creators who should not be spending their
            best energy duct-taping the business together.
          </motion.p>

          <motion.p
            {...fadeUp}
            className="mt-6 text-[#A8A39D] leading-relaxed max-w-[44ch]"
          >
            We step in as the operator behind the brand, designing and building
            the systems that make monetization cleaner, conversion stronger, and
            growth more functional.
          </motion.p>
        </div>

        <div className="lg:col-span-7 lg:pl-12 lg:border-l lg:border-[#282930]">
          <motion.div {...staggerContainer} className="grid sm:grid-cols-2 gap-x-8">
            {offerings.map((o, i) => (
              <motion.div
                {...staggerChild}
                key={o}
                className="py-5 border-b border-[#1D1E24] flex items-baseline gap-4"
              >
                <span className="font-display text-[#C9A26B] text-sm tabular-nums w-6">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-[#F4EFE6]">{o}</span>
              </motion.div>
            ))}
          </motion.div>

          <motion.p
            {...fadeUp}
            className="mt-12 font-display text-xl md:text-2xl leading-snug text-[#F4EFE6]"
          >
            The result is not more complexity.
            <br />
            <span className="italic text-[#C9A26B]">It&rsquo;s a business that makes sense.</span>
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default Solution;
